
  
// Script Généré le : 10/01/2026 10:38:10 via ModelGenerator.nt
//  SourcingParameters.ts
// Chemin de sortie : ..\..\..\front-shared\paf-shared\projects\ngx-paf-common\src\lib\Models\SourcingParameters.ts

export class SourcingParameters {

  // int? IntUserId
  public IntUserId?: number=null;

  // string LngCod
  public LngCod?: string=null;

  // int[] FamiliesIds
  public FamiliesIds: number[]=[];

  // string NameOrNumTiers
  public NameOrNumTiers?: string=null;

  // string UniqueId
  public UniqueId?: string=null;

  // int[] RegionIds
  public RegionIds: number[]=[];

  // int[] DepartmentIds
  public DepartmentIds: number[]=[];

  // string SupplierContactMask
  public SupplierContactMask?: string=null;

  // string[] RegionalPanels
  public RegionalPanels: string[]=[];

  // int[] CertOrQualifDocIds
  public CertOrQualifDocIds: number[]=[];

  // bool TopExcelFull
  public TopExcelFull: boolean=false;

  // int TopESAT
  public TopESAT: number=0;
}